





















import { Component, Watch } from 'nuxt-property-decorator'
import { ModalComponentBaseVue } from '@/base'
import ModalFooter from '@/components/molecules/ModalFooter/ModalFooter.vue'
import ConfirmationLendCountTable from '@/components/organisms/ConfirmationLendCountTable/ConfirmationLendCountTable.vue'
import {
  AlertMessage,
  BibliographyLendCount,
  ErrorMessage,
  bibliographyApi
} from '@/api'
import { alertStore, modalErrorStore } from '@/utils/store-accessor'
import { NAV_LOADING_END, NAV_LOADING_START } from '@/config/event'

export interface ModalConfirmationLendCountInterface {
  bibliographyId: number
}

@Component({
  components: {
    ConfirmationLendCountTable,
    ModalFooter
  }
})
export default class ModalConfirmationLendCount extends ModalComponentBaseVue {
  dialog: boolean = false

  lendCount: BibliographyLendCount[] = []

  tableBodyHeight: number = 0

  bibliographyId: number = 0

  @Watch('dialog')
  initialize(newVal: boolean): void {
    if (newVal) {
      this.getLendCount()
      this.$nextTick(() => {
        window.addEventListener('resize', this.onResize)
        this.calculateTableHeight()
      })
    }

    this.lendCount = []
    this.bibliographyId = 0
    window.removeEventListener('resize', this.onResize)
  }

  calculateTableHeight(): void {
    this.tableBodyHeight = 0

    this.$nextTick(() => {
      this.tableBodyHeight = this.calculateTableHeightBase()
    })
  }

  onResize(): void {
    this.calculateTableHeight()
  }

  open(params: ModalConfirmationLendCountInterface): void {
    this.bibliographyId = params.bibliographyId
    this.dialog = true
  }

  close(): void {
    this.dialog = false
  }

  print() {
    const element = document.getElementById('modal-confirmation-lend-count')
    if (element) {
      this.$webSocket.sendDialogScreenshotMessage(element)
    } else {
      this.$webSocket.sendScreenshotMessage()
    }
  }

  async getLendCount(): Promise<void> {
    this.$eventBus.emit(NAV_LOADING_START)

    try {
      this.lendCount = await bibliographyApi.getBibliographyLendCounts(
        this.bibliographyId
      )
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
      close()
    } finally {
      this.$eventBus.emit(NAV_LOADING_END)
    }
  }
}
